import React from 'react';
import { globalSettings } from '../../helpers/settings'

//#region old code

// export default class Footer extends Component {
//     render() {
//         return (
//             <div>
//                 <a id='back-to-top' href='#top' className='btn btn-outline-primary back-to-top' role='button' aria-label='Scroll to top'>
//                     <i className={globalSettings?.icons?.chevronUp} />
//                 </a>

//                 <footer className='main-footer'>
//                     <strong>{globalSettings?.labels?.copyright.en} &copy; {globalSettings?.app?.year} <a href={globalSettings?.app?.company?.url} target='_blank' rel='noreferrer'>{globalSettings?.app?.company?.name}</a> </strong>
//                     {globalSettings?.messages?.allRightsReserved.en}.
//                     <div className='float-right d-none d-sm-inline-block'>
//                         <b>{globalSettings?.labels?.version.en}</b> {globalSettings?.app?.version}
//                     </div>
//                 </footer>
//             </div>
//         )
//     }
// }

//#endregion old code

export default function Footer() {
    return (
        <div><div>
            <a id='back-to-top' href='#top' className='btn btn-outline-primary back-to-top' role='button' aria-label='Scroll to top'>
                <i className={globalSettings?.icons?.chevronUp} />
            </a>

            <footer className='main-footer'>
                <strong>{globalSettings?.labels?.copyright.en} &copy; {globalSettings?.app?.year} <a href={globalSettings?.app?.company?.url} target='_blank' rel='noreferrer'>{globalSettings?.app?.company?.name}</a> </strong>
                {globalSettings?.messages?.allRightsReserved.en}.
                <div className='float-right d-none d-sm-inline-block'>
                    <b>{globalSettings?.labels?.version.en}</b> {globalSettings?.app?.version}
                </div>
            </footer>
        </div></div>
    )
}